
import { WeeklyMenu, Recipe, ShoppingListItem, ShoppingList } from '@/types';

export const generateShoppingListFromMenu = (
  weeklyMenu: WeeklyMenu,
  recipes: Recipe[]
): Record<string, ShoppingListItem> => {
  console.log('🛒 Starting shopping list generation');
  console.log('📅 Weekly menu:', weeklyMenu);
  console.log('📚 Available recipes:', recipes?.length || 0);
  
  const combinedIngredients: Record<string, ShoppingListItem> = {};
  
  // Process all days in the weekly menu
  const daysToProcess = [
    'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday',
    'monday2', 'tuesday2', 'wednesday2', 'thursday2', 'friday2', 'saturday2', 'sunday2'
  ];
  
  daysToProcess.forEach((dayKey) => {
    const dayData = weeklyMenu.days?.[dayKey];
    if (!dayData) {
      console.log(`❌ No data for day: ${dayKey}`);
      return;
    }
    
    console.log(`🗓️ Processing day ${dayKey}:`, dayData);
    
    // Process each meal type
    Object.entries(dayData).forEach(([mealType, mealData]) => {
      if (mealType === 'customIngredients') {
        // Handle custom ingredients
        if (Array.isArray(mealData)) {
          console.log(`🥗 Processing ${mealData.length} custom ingredients for ${dayKey}`);
          mealData.forEach((ingredient: any) => {
            if (ingredient && ingredient.name) {
              const ingredientKey = `${ingredient.name}-${ingredient.unit || 'g'}`;
              
              if (combinedIngredients[ingredientKey]) {
                combinedIngredients[ingredientKey].amount += 
                  parseFloat(String(ingredient.quantity)) || 0;
              } else {
                combinedIngredients[ingredientKey] = {
                  name: ingredient.name,
                  amount: parseFloat(String(ingredient.quantity)) || 0,
                  unit: ingredient.unit || 'g',
                  checked: false
                };
              }
              console.log(`✅ Added custom ingredient: ${ingredient.name}`);
            }
          });
        }
      } else {
        // Handle recipe meals
        if (Array.isArray(mealData)) {
          console.log(`🍽️ Processing ${mealData.length} meals for ${mealType} on ${dayKey}`);
          mealData.forEach((meal: any) => {
            if (meal && meal.recipeId) {
              console.log(`🔍 Looking for recipe with ID: ${meal.recipeId}`);
              const recipe = recipes.find(r => r.id === meal.recipeId);
              if (recipe && recipe.ingredients) {
                const portionMultiplier = parseFloat(String(meal.portionSize)) || 1;
                
                console.log(`📖 Processing recipe: ${recipe.title} (${recipe.ingredients.length} ingredients) with portion ${portionMultiplier}`);
                
                recipe.ingredients.forEach((ing) => {
                  if (ing && ing.name) {
                    const ingredientKey = `${ing.name}-${ing.unit || 'g'}`;
                    const amount = (parseFloat(String(ing.amount)) || 0) * portionMultiplier;
                    
                    if (combinedIngredients[ingredientKey]) {
                      combinedIngredients[ingredientKey].amount += amount;
                      console.log(`➕ Updated ingredient: ${ing.name} - total: ${combinedIngredients[ingredientKey].amount} ${ing.unit}`);
                    } else {
                      combinedIngredients[ingredientKey] = {
                        name: ing.name,
                        amount: amount,
                        unit: ing.unit || 'g',
                        checked: false
                      };
                      console.log(`✨ Added new ingredient: ${ing.name} - ${amount} ${ing.unit}`);
                    }
                  }
                });
              } else {
                console.log(`❌ Recipe not found for ID: ${meal.recipeId}`);
              }
            }
          });
        }
      }
    });
  });

  console.log('🎯 Final shopping list ingredients:', Object.keys(combinedIngredients));
  console.log('📊 Total unique ingredients:', Object.keys(combinedIngredients).length);
  return combinedIngredients;
};

export const preserveCheckedStatus = (
  newIngredients: Record<string, ShoppingListItem>,
  existingShoppingList: ShoppingList | null
): Record<string, ShoppingListItem> => {
  if (!existingShoppingList) return newIngredients;

  Object.keys(newIngredients).forEach(key => {
    if (existingShoppingList.items[key]) {
      newIngredients[key].checked = existingShoppingList.items[key].checked;
    }
  });

  return newIngredients;
};
